<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-12-28 14:45:11
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-04 14:00:52
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
  >
    <el-form
      style="margin: 20px 0"
      ref="form"
      size="small"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >

      <el-form-item
        label="按钮名称"
        prop="text"
      >
        <el-input
          v-model="form.text"
          clearable
          placeholder="请输入"
          style="width: 200px"
        />
      </el-form-item>

      <el-form-item label="禁用">
        <el-switch
          v-model="form.disabled"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="圆角">
        <el-switch
          v-model="form.round"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="朴素">
        <el-switch
          v-model="form.plain"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="字号大小">
        <el-input-number
          v-model="form.fontSize"
          clearable
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="form.fontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="form.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="背景颜色">
        <el-color-picker
          v-model="form.backgroundColor"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="链接地址">
        <el-input
          placeholder="如：http://www.wiseloong.com?id=${id}&name=${name}"
          style="width: 100%"
          type="textarea"
          rows="2"
          v-model="form.url"
        >
        </el-input>
        <div class="xa-form-tips">
          <span>备注: 输入完整(http://www.xxxx)的地址可以在新窗口中打开！</span>
          <span>参数uuid配置格式为 xx=${uuid}&xxx=${uuid32}</span>
        </div>
      </el-form-item>

    </el-form>
    <span slot="footer">
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  predefineColors,
  theme,
  component
} from '@/dragComponents/model/default.js'

export default {
  name: 'button-dialog',
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      form: {},
      weightList: component.weightType,
      alignList: component.alignType,
      rules: {
        text: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  watch: {
    column(val) {
      this.form = val
    },
    form: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((bool) => {
        if (bool) {
          this.$emit('change', this.form)
          this.dialog.show = false
        }
      })
    }
  }
}
</script>
